module.exports = __webpack_public_path__ + "img/botella_azul_outline_1.d8ebdb80.png";